import * as React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchStyle } from '../../pages/PatientManagement/style';
import SearchIcon from '@mui/icons-material/Search';
import { colors } from '../../constants';

interface Props {
  placeholder?: string;
  searchValue: string;
  handleSearchChange: (value: string) => void;
}

export default function SearchBox({ placeholder, searchValue, handleSearchChange }: Props) {
  const { t } = useTranslation();

  return (
    <SearchStyle>
      <Box className="input-Base-style">
        <TextField
          value={searchValue}
          sx={{ marginTop: '10px' }}
          onChange={(e) => handleSearchChange(e.target.value)}
          variant="outlined"
          placeholder={placeholder ? t(placeholder) : t('chat.search')}
          size="small"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: colors.blueBase }} />
              </InputAdornment>
            )
          }}
        />
      </Box>
    </SearchStyle>
  );
}
